__turbopack_context__.v({
  "atc": "AddToCartButton-module-scss-module__FysyBG__atc",
  "atc--full": "AddToCartButton-module-scss-module__FysyBG__atc--full",
  "atc__btn": "AddToCartButton-module-scss-module__FysyBG__atc__btn",
  "atc__error": "AddToCartButton-module-scss-module__FysyBG__atc__error",
  "atc__hint": "AddToCartButton-module-scss-module__FysyBG__atc__hint",
  "atc__loading": "AddToCartButton-module-scss-module__FysyBG__atc__loading",
  "atc__success": "AddToCartButton-module-scss-module__FysyBG__atc__success",
});
